import { FilterOption } from '../../../components/_WMS/FilterComponent'
import { PositionAutoCompleter } from '../../../components/PositionNew/components/PositionAutoCompleter'
import { createBackendTransformer, createDisplayTransformer } from '../../../types/filters'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'stockKeepingUnit',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 3,
    key: 'ean13',
    label: 'EAN13',
    type: 'text'
  },
  {
    order: 4,
    key: 'typePositionId',
    label: 'Tipo Posición',
    type: 'precreated'
  },
  {
    order: 5,
    key: 'zoneId',
    label: 'Zona',
    type: 'precreated'
  },
  {
    order: 6,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 7,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  },
  {
    order: 8,
    key: 'positionCode',
    label: 'Nombre Posición',
    type: 'custom',
    Component: PositionAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 9,
    key: 'BatchNumber',
    label: 'Lote',
    type: 'text'
  },
  {
    order: 10,
    key: 'batchExpiredStatus',
    label: 'Estado de vencimiento',
    type: 'precreated'
  },
  {
    order: 11,
    key: 'batchControl',
    label: 'Control Fefo',
    type: 'precreated'
  },
  {
    order: 12,
    key: 'dateRange',
    label: 'Rango de Fechas Expiración',
    type: 'daterange',
    canBeRepeated: false
  }
]

export const defaultFiltersStock = [
  {
    key: 'batchExpiredStatus',
    label: 'Estado de vencimiento',
    value: '1',
    displayValue: 'Vigente'
  }
]

export interface SearchBatchDetail {
  stockKeepingUnitId: number
  positionId: number
  sku: string
  positionCode: string
}
